import { FilterItem } from '../../services/types/services'

export const applySelectedFilters = (
  filters: FilterItem[],
  selectedFilters: string[],
) => {
  return filters.reduce((acc: FilterItem[], filter: FilterItem) => {
    if (filter.__typename === 'FilterCategory') {
      const updatedChildren = applySelectedFilters(
        filter.children,
        selectedFilters,
      )
      acc.push({ ...filter, children: updatedChildren })
    } else if (filter.__typename !== 'FilterHeader') {
      acc.push({
        ...filter,
        isSelected: filter.isSelected || selectedFilters.includes(filter.id),
      })
    } else {
      acc.push(filter)
    }
    return acc
  }, [])
}
